module.exports = __webpack_public_path__ + "static/media/ico_partner_o.97f1a943.svg";